/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 我关注或者取消关注旗舰店
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  theaterId: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/attention/${theaterId}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
